import { render, staticRenderFns } from "./QuotationSummary.vue?vue&type=template&id=648e21cc"
import script from "./QuotationSummary.vue?vue&type=script&lang=js"
export * from "./QuotationSummary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports